<div class="sidebar-content">
  <div class="sidebar-logo">
    <a class="logo-container cursor-pointer" routerLink="/home">
      <img src="assets/images/logo-wide.svg" alt="Logo" class="logo" />
    </a>
  </div>
  <a
    class="inwi-nav-link"
    [routerLink]="['./seminars']"
    [routerLinkActive]="['is-active']">
    <div class="nav-link-content">
      <div class="nav-link-content-icon">
        <i class="fa-regular fa-book-copy"></i>
      </div>
      <div class="nav-link-content-title">Seminare</div>
      <div class="nav-link-content-badge"></div>
    </div>
  </a>
  <a
    class="inwi-nav-link"
    [routerLink]="['./seminar-attachments']"
    [routerLinkActive]="['is-active']">
    <div class="nav-link-content">
      <div class="nav-link-content-icon">
        <i class="fa-regular fa-paperclip-vertical"></i>
      </div>
      <div class="nav-link-content-title">Seminar Unterlagen</div>
      <div class="nav-link-content-badge"></div>
    </div>
  </a>
  <a
    class="inwi-nav-link"
    [routerLink]="['./news-banners']"
    [routerLinkActive]="['is-active']">
    <div class="nav-link-content">
      <div class="nav-link-content-icon">
        <i class="fa-regular fa-newspaper"></i>
      </div>
      <div class="nav-link-content-title">News Banner</div>
      <div class="nav-link-content-badge"></div>
    </div>
  </a>

  <a
    class="inwi-nav-link"
    [routerLink]="['./bookings']"
    [routerLinkActive]="['is-active']">
    <div class="nav-link-content">
      <div class="nav-link-content-icon">
        <i class="fa-regular fa-graduation-cap"></i>
      </div>
      <div class="nav-link-content-title">Buchungen</div>
      <div class="nav-link-content-badge"></div>
    </div>
  </a>
  <a
    class="inwi-nav-link"
    [routerLink]="['./invoices']"
    [routerLinkActive]="['is-active']">
    <div class="nav-link-content">
      <div class="nav-link-content-icon">
        <i class="fa-regular fa-receipt"></i>
      </div>
      <div class="nav-link-content-title">Rechnungen</div>
      <div class="nav-link-content-badge"></div>
    </div>
  </a>
  <a
    class="inwi-nav-link"
    [routerLink]="['./coupons']"
    [routerLinkActive]="['is-active']">
    <div class="nav-link-content">
      <div class="nav-link-content-icon">
        <i class="fa-regular fa-ticket"></i>
      </div>
      <div class="nav-link-content-title">Gutscheine</div>
      <div class="nav-link-content-badge"></div>
    </div>
  </a>
  <a
    class="inwi-nav-link"
    [routerLink]="['./training-categories']"
    [routerLinkActive]="['is-active']">
    <div class="nav-link-content">
      <div class="nav-link-content-icon">
        <i class="fa-regular fa-book-bookmark"></i>
      </div>
      <div class="nav-link-content-title">Fortbildungs Kategorien</div>
      <div class="nav-link-content-badge"></div>
    </div>
  </a>
  <a
    class="inwi-nav-link"
    [routerLink]="['./member-areas']"
    [routerLinkActive]="['is-active']">
    <div class="nav-link-content">
      <div class="nav-link-content-icon">
        <i class="fa-regular fa-folders"></i>
      </div>
      <div class="nav-link-content-title">Mitgliederbereiche</div>
      <div class="nav-link-content-badge"></div>
    </div>
  </a>
  <a
    class="inwi-nav-link"
    [routerLink]="['./contacts']"
    [routerLinkActive]="['is-active']">
    <div class="nav-link-content">
      <div class="nav-link-content-icon">
        <i class="fa-regular fa-user"></i>
      </div>
      <div class="nav-link-content-title">Alle Kontakte</div>
      <div class="nav-link-content-badge"></div>
    </div>
  </a>
</div>
